import { c as _c } from "react/compiler-runtime";
import type { AuditEventDetail, TenantScope } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import useGetRoleText from '../../role-display/role-permissions/use-get-role-text';
import getScopeDiff from './get-scope-diff';
const RoleDiff = t0 => {
  const $ = _c(38);
  const {
    detail
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.roles"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  const getRoleText = useGetRoleText();
  if (detail.kind !== "update_org_role") {
    return null;
  }
  const {
    prevScopes,
    newScopes
  } = detail.data;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[1] !== getRoleText || $[2] !== newScopes || $[3] !== prevScopes || $[4] !== t) {
    const {
      oldScopesRemoved,
      newScopesAdded,
      commonScopes
    } = getScopeDiff(prevScopes, newScopes);
    let t9;
    if ($[12] !== getRoleText) {
      t9 = scope => getRoleText(scope as TenantScope);
      $[12] = getRoleText;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    const commonScopesText = commonScopes.map(t9);
    let t10;
    if ($[14] !== getRoleText) {
      t10 = scope_0 => getRoleText(scope_0 as TenantScope);
      $[14] = getRoleText;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    const oldScopesText = oldScopesRemoved.map(t10);
    let t11;
    if ($[16] !== getRoleText) {
      t11 = scope_1 => getRoleText(scope_1 as TenantScope);
      $[16] = getRoleText;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    const newScopesText = newScopesAdded.map(t11);
    t7 = "flex flex-col gap-4";
    let t12;
    if ($[18] !== t) {
      t12 = t(_temp);
      $[18] = t;
      $[19] = t12;
    } else {
      t12 = $[19];
    }
    let t13;
    if ($[20] !== t12) {
      t13 = <h3 className="text-label-2">{t12}</h3>;
      $[20] = t12;
      $[21] = t13;
    } else {
      t13 = $[21];
    }
    t8 = <div className="flex flex-col gap-4 p-4 rounded bg-secondary">{t13}<div className="grid grid-cols-1 sm:grid-cols-2 gap-4">{commonScopesText.map(_temp2)}{newScopesText.map(_temp3)}</div></div>;
    t5 = "flex flex-col gap-4 p-5 rounded bg-secondary";
    let t14;
    if ($[22] !== t) {
      t14 = t(_temp4);
      $[22] = t;
      $[23] = t14;
    } else {
      t14 = $[23];
    }
    if ($[24] !== t14) {
      t6 = <h3 className="text-label-2">{t14}</h3>;
      $[24] = t14;
      $[25] = t6;
    } else {
      t6 = $[25];
    }
    t2 = "grid grid-cols-1 sm:grid-cols-2 gap-x-9 gap-y-4";
    t3 = commonScopesText.map(_temp5);
    t4 = oldScopesText.map(_temp6);
    $[1] = getRoleText;
    $[2] = newScopes;
    $[3] = prevScopes;
    $[4] = t;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
  }
  let t9;
  if ($[26] !== t2 || $[27] !== t3 || $[28] !== t4) {
    t9 = <div className={t2}>{t3}{t4}</div>;
    $[26] = t2;
    $[27] = t3;
    $[28] = t4;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== t5 || $[31] !== t6 || $[32] !== t9) {
    t10 = <div className={t5}>{t6}{t9}</div>;
    $[30] = t5;
    $[31] = t6;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== t10 || $[35] !== t7 || $[36] !== t8) {
    t11 = <div className={t7}>{t8}{t10}</div>;
    $[34] = t10;
    $[35] = t7;
    $[36] = t8;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  return t11;
};
export default RoleDiff;
function _temp($) {
  return $.newPermissions;
}
function _temp2(scopeText) {
  return <p key={scopeText} className="text-body-2">{scopeText}</p>;
}
function _temp3(scopeText_0) {
  return <p key={scopeText_0} className="text-body-2 text-success">{scopeText_0} (+)</p>;
}
function _temp4($_0) {
  return $_0.oldPermissions;
}
function _temp5(scopeText_1) {
  return <p key={scopeText_1} className="text-body-2">{scopeText_1}</p>;
}
function _temp6(scopeText_2) {
  return <p key={scopeText_2} className="text-body-2 text-error">{scopeText_2} (-)</p>;
}